import { Button } from 'component/Button'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { opt } from 'store/opt'

type Props = {
  action: () => void
  disabled?: boolean
}

export const ContinueButton = observer(({ action, disabled }: Props) => {
  return <Button wide large primary disabled={disabled} action={action}>
    <Space gap={16}>
      <Typo>
        {i18n('Continue')}
      </Typo>
      {opt.basic && <Icon size={26} name="arrow_forward_ios" />}
    </Space>
  </Button>
})
